import GridLayoutUtils from 'presentation/components/grid-layout/utils.js';
import { useMemo } from 'react';

const GridCell = props => {
    const {
        mojitoTools: { config },
        children,
        onClick,
        startColumn,
        endColumn,
        startRow,
        endRow,
        elementRef,
    } = props;

    const style = useMemo(() => {
        return GridLayoutUtils.enrichGridLayout(
            config.style,
            startColumn,
            endColumn,
            startRow,
            endRow,
            config.useAbsolutePosition
        );
    }, [config, startColumn, endColumn, startRow, endRow]);

    return (
        <div style={style} className={props.class} onClick={onClick} ref={elementRef}>
            {children}
        </div>
    );
};

export default GridCell;
